// Hebrew, he-IL

export default {
	TOGGLE_DRAWER: `הצג או הסתר תפריט`,
	UNFAVORITE: `הסר ממועדפים`,
	__ASK_FOR_HELP: `* בקשת עזרה`,
	__TIME_IS_UP: `* הזמן נגמר`,
	A_NEW_SUBSCRIPTION_WILL_BE_CREATED: `מנוי חדש ייווצר`,
	ACCOUNT_CREATED_WELCOME: `ברוכים הבאים! יצרנו עבורך חשבון חדש.`,
	ACCOUNT_LOGIN: `כניסה לחשבון`,
	ACCOUNT_REGISTRATION: `הרשמת חשבון`,
	ACTION_FAILED: `הפעולה נכשלה`,
	ACTION_MENU: `תפריט פעולות`,
	ACTION_WAS_SUCCESSFUL: `הפעולה הצליחה`,
	ACTIVE: `פעיל`,
	ACTIVE_SUBSCRIPTIONS: `מנויים פעילים`,
	ADD: `הוסף`,
	ADD_NEW: `הוסף חדש`,
	ADD_NEW_ASSIGNMENT: `הוסף שיעור`,
	ADD_TO_FAVORITES: `הוסף למועדפים`,
	ADD_USER: `הוסף משתמש`,
	ADDRESS: `כתובת`,
	ADVANCED_SEARCH: `חיפוש מתקדם`,
	AFTER_A_MISTAKE: `אחרי טעות`,
	ANDROID_INSTALL_UNAVAILABLE_CAPTION: `פתחו את תפריט הדפדפן (⋮) ובחרו "התקנת אפליקציה" או "הוספה למסך הבית".`,
	ANDROID_INSTALL_UNAVAILABLE_MESSAGE: `חלון ההתקנה אינו זמין כרגע`,
	AN_ERROR_MESSAGE_WILL_BE_SHOWN: `תוצג הודעת שגיאה`,
	ANSWER: `תשובה`,
	APPEARANCE: `מראה`,
	APPLY: `החל`,
	APP_INSTALLED_SUCCESSFULLY: `האפליקציה הותקנה בהצלחה!`,
	APPROVE: `אישור הבקשה`,
	APPROVE_NOTIFICATIONS_REQUEST: `כדי לראות התראות בנוגע לעדכונים ופעולות, יש לאשר קבלת התראות. האם תרצה לקבל התראות? (יש לאשר קבלת התראות)`,
	APPROVED: `אושר`,
	ARE_YOU_SURE_REMOVE_USER_COURSE: `האם אתה בטוח שתרצה להסיר את הקורס הזה מהקורסים שלך? כל ההתקדמות שלך תאבד.`,
	ARE_YOU_SURE_YOU_WANT_TO_DELETE: `בטוחים שתרצו למחוק?`,
	ARE_YOU_SURE_YOU_WANT_TO_TOGGLE_ACTIVE: `אתם בטוחים שתרצו לשנות מצב פעיל`,
	ARE_YOU_SURE_YOU_WANT_TO_TOGGLE_PERIOD: `בטוחים שתרצו לשנות את התקופה, התשלום הבא יהיה בהתאם לתקופה שתשנו.`,
	ARE_YOU_SURE_YOU_WANT_TO_UNSUBSCRIBE: `בטוחים שתרצו לבטל את המנוי? לא יבוצעו תשלומים נוספים. הרישיון יהיה זמין עד סוף התקופה.`,
	ASSIGN: `שייך`,
	ASSIGN_LICENSE_TO_CHILD: `שייך רישיון לילד`,
	ASSIGNMENTS: `שיבוצים`,
	ASSIGNED_COURSES: `קורסים משויכים`,
	ASSIGNED_SECTIONS: `פרקים משויכים`,
	AT: `ב`,
	AUDIO_SETTINGS: `הגדרות קול`,
	AUTHENTICATION_FAIL: `הזדהות נכשלה`,
	AVAILABLE_ANSWERS: `תשובות אפשריות`,
	AVERAGE_SCORE: `ציון ממוצע`,
	AVATAR: `אווטאר`,
	AVATAR_MANAGEMENT: `ניהול אווטאר`,
	AVATAR_SAVED_SUCCESS: `האווטאר נשמר בהצלחה!`,
	AVATAR_SAVED_ERROR: `שמירת האווטאר נכשלה`,
	AVATAR_DELETED_SUCCESS: `האווטאר נמחק בהצלחה!`,
	AVATAR_DELETED_ERROR: `מחיקת האווטאר נכשלה`,
	AVATAR_DOWNLOAD_PNG: `הורדת PNG`,
	AVATAR_DOWNLOAD_SVG: `הורדת SVG`,
	AVATAR_RANDOMIZE: `אקראי`,
	AVATAR_RESTORE_SAVED: `שחזור האווטאר השמור`,
	AVATAR_SAVE_TO_PROFILE: `שמירה לפרופיל`,
	BACK: `הקודם`,
	BACK_TO_LOGIN: `חזרה לדף הכניסה`,
	BACK_TO_STEP_LIST: `חזרה לרשימת שלבים`,
	BILLING: `חיוב`,
	BILLING_SETTINGS: `הגדרות חיוב`,
	BIRTH_DATE: `תאריך לידה`,
	BLANK_NOT_FOUND: `החסר לא נמצא`,
	BLOCK_USER: `חסום משתמש`,
	BUY_LICENSE: `קנה רישיון`,
	CANCEL: `ביטול`,
	CANCELED: `בוטל`,
	CANCLE: `ביטול`,
	CATEGORY_BREAKDOWN: `התפלגות לפי קטגוריה`,
	CHANGE_PASSWORD: `שנה סיסמה`,
	CHECKOUT: `תשלום`,
	CHILD_ACCOUNT: `חשבון ילד`,
	CHILD_ACCOUNT_LOGIN: `כניסה לחשבון ילד`,
	CHILD_LOGIN_TOKEN_INSTRUCTIONS: `העתק את קוד הכניסה למטה ושלח אותו לילדך. הילד ישתמש בקוד זה כדי להתחבר לחשבונו.`,
	CHILD_LOGIN_CARD_STEP_1: `הילד יקבל קוד כניסה באמצעות אימייל.`,
	CHILD_LOGIN_CARD_STEP_2: `הילד יקליד את הקוד בדף הכניסה ויגש להתחברות.`,
	CHILD_LOGIN_CARD_TITLE: `איך להתחבר לחשבון שלך?`,
	CHILDREN_MANAGEMENT: `ניהול ילדים`,
	CHILD_LOGIN_TOKEN_NOT_FOUND: `אין עדיין קוד כניסה. צרו קוד עבור הילד.`,
	CHILED_LOGIN_TOKEN: `קוד כניסה לילד`,
	CHOOSE_A_PLAN: `בחר מסלול`,
	CITY: `עיר`,
	CLASS: `כיתה`,
	CLEAR_ALL: `נקה הכל`,
	CLEAR_NOW: `נקה עכשיו`,
	CLEAR_STORAGE: `נקה זיכרון אפליקציה`,
	CLEAR_STORAGE_DESCRIPTION: `אם האפליקציה לא מתפקדת כראוי, ניקוי זיכרון האפליקציה עשוי לעזור.`,
	CLEAR_STORAGE_WARNING: `ההתקדמות שלך בקורס ומידע אישי לא יושפעו מכך`,
	CLOSE: `סגור`,
	CODE_COPIED: `הקוד הועתק`,
	COLLAPSE: `צמצם`,
	COLLAPSE_SIDEBAR: `צמצם סרגל צד`,
	COMMENT: `הערה`,
	COMPLETED: `הושלם`,
	COMPLETED_COURSES: `קורסים שהושלמו`,
	COMPLETED_SECTIONS: `פרקים שהושלמו`,
	COMPLETED_STEPS: `שלבים שהושלמו`,
	COMPLETED_STEP_BANNER_MESSAGE: `האם תרצה להמשיך לשלב הבא?`,
	COMPLETED_STEP_BANNER_TEXT: `השלמת את השלב בהצלחה`,
	COMPLETE_STEP: `סיום שלב`,
	COMPLETION_FEEDBACK: `משוב על סיום`,
	CONFIRM: `אישור`,
	CONFIRM_NEW_PASSWORD: `אישור סיסמה חדשה`,
	CONFIRM_UNSUBSCRIBE: `אישור ביטול מנוי`,
	CONTENT_EMPTY_COURSE_CHILD: `עדיין אין לך קורסים. בקר בחנות הקורסים ובחר קורס כדי להתחיל.`,
	CONTENT_EMPTY_COURSE_STUDENT: `עדיין אין לך קורסים. המורה מקצה קורסים לכיתה שלך — בקש מהמורה להקצות לך קורס.`,
	CONTENT_EMPTY_COURSE_TITLE: `עדיין אין קורסים`,
	CONTENT_EMPTY_GENERIC: `אין כאן עדיין מה להציג.`,
	CONTENT_EMPTY_SECTION_CHILD: `עדיין אין לך פרקים. בקר בחנות ובחר פרק כדי להתחיל.`,
	CONTENT_EMPTY_SECTION_STUDENT: `עדיין אין לך פרקים. המורה מקצה פרקים לכיתה שלך — בקש מהמורה להקצות לך פרק.`,
	CONTENT_EMPTY_SECTION_TITLE: `עדיין אין פרקים`,
	CONTENT_EMPTY_TEACHER_PREVIEW: `עדיין לא הצגת תוכן. פתח את אחת הכיתות שלך ולחץ על תצוגה מקדימה בקורס או פרק שהוקצה.`,
	COPIED_TO_CLIPBOARD: `הועתק ללוח`,
	COPY_CODE: `העתק קוד`,
	COPY_TO_CLIPBOARD: `העתק ללוח`,
	CORRECT: `נכון`,
	CORRECT_ANSWER: `תשובה נכונה`,
	COUNTRY: `ארץ`,
	COURSE: `קורס`,
	COURSE_ASSIGNED_SUCCESSFULLY: `הקורס הוקצה בהצלחה`,
	COURSE_COMPLETED: `הקורס הושלם`,
	COURSE_NAME: `שם הקורס`,
	COURSE_TYPE_FREE: `חינם`,
	COURSE_TYPE_PREMIUM: `פרימיום`,
	COURSE_PREVIEW: `תצוגה מקדימה של קורסים`,
	COURSE_REMOVED_SUCCESSFULLY: `הקורס הוסר בהצלחה`,
	COURSE_SECTION: `פרק קורס`,
	COURSE_SECTIONS: `פרקי הקורס`,
	COURSE_STORE: `חנות קורסים`,
	COURSES: `קורסים`,
	CROSSMATCH: `CrossMatch`,
	CURRENT_STREAK: `רצף נוכחי`,
	CURRENT_PASSWORD: `סיסמה נוכחית`,
	DAILY: `יומי`,
	DASHBOARD: `לוח מחוונים`,
	DATE: `תאריך`,
	DAY: `יום`,
	DAYS_AGO: `לפני {count} ימים`,
	DELETE: `מחיקה`,
	DELETE_USER: `מחק משתמש`,
	DETAILS: `פרטים`,
	DIGITS_ONLY: `ספרות בלבד`,
	DISMISS: `שחרר`,
	DONT_HAVE_AN_ACCOUNT: `אין לך חשבון`,
	DRILL: `תרגיל`,
	DRILL_DESCRIPTION: `תיאור תרגיל`,
	DRILL_TYPE: `סוג תרגיל`,
	EDIT: `עריכה`,
	EDIT_DETAILS: `עריכת פרטים`,
	EDIT_USER: `ערוך משתמש`,
	EDIT_USER_DETAILS: `ערוך פרטי משתמש`,
	EMAIL: `אימייל`,
	ENABLE_EDITING: `אפשר עריכה`,
	END_ALL: `סיים פרק`,
	ENROLLMENT_STATUS_ACTIVE_ACTION: `אין צורך בפעולה — בחר את הכיתה הזו במסנן כדי לראות רק את הקורסים והפרקים שלה.`,
	ENROLLMENT_STATUS_ACTIVE_MESSAGE: `אתה רשום לכיתה הזו. הקורסים והפרקים שלה זמינים לך עכשיו.`,
	ENROLLMENT_STATUS_COMPLETED_ACTION: `אין צורך בפעולה — כל הכבוד. כדי להצטרף לכיתה חדשה, בקש מהמורה הזמנה.`,
	ENROLLMENT_STATUS_COMPLETED_MESSAGE: `סיימת את הכיתה הזו. הקורסים והפרקים שלה כבר אינם חלק מהמשימות הפעילות שלך.`,
	ENROLLMENT_STATUS_DECLINED_ACTION: `בדוק עם המורה שבחרת בכיתה הנכונה, ובקש הזמנה חדשה.`,
	ENROLLMENT_STATUS_DECLINED_MESSAGE: `בקשתך להצטרף לכיתה הזו נדחתה, ולכן אין לך גישה לחומר שלה.`,
	ENROLLMENT_STATUS_DROPPED_ACTION: `פנה למורה אם לדעתך מדובר בטעות — הוא יכול לרשום אותך מחדש.`,
	ENROLLMENT_STATUS_DROPPED_MESSAGE: `הוסרת מהכיתה הזו, ולכן הקורסים והפרקים שלה כבר אינם משויכים אליך.`,
	ENROLLMENT_STATUS_PENDING_ACTION: `בקש מהמורה לאשר את הבקשה. לא נדרשת ממך פעולה נוספת.`,
	ENROLLMENT_STATUS_PENDING_MESSAGE: `בקשתך להצטרף לכיתה הזו ממתינה לאישור המורה. עד אז הקורסים והפרקים שלה מוסתרים.`,
	ENROLLMENT_STATUS_UNKNOWN_ACTION: `נסה לרענן את הדף. אם זה נמשך, בקש מהמורה לבדוק את הרישום שלך.`,
	ENROLLMENT_STATUS_UNKNOWN_MESSAGE: `לא הצלחנו לקרוא את הסטטוס של הרישום הזה.`,
	ENROLLMENT_STATUS_WHAT_TO_DO: `מה אפשר לעשות`,
	ENTER: `כניסה`,
	ENTER_YOUR_EMAIL_ADDRESS: `הזן את כתובת הדוא”ל שלך`,
	ERROR: `שגיאה`,
	ERROR_ASSIGNING_COURSE: `שגיאה בהקצאת קורס`,
	ERROR_FETCHING_DATA: `שגיאה בטעינת נתונים`,
	ERROR_NO_ACCOUNT_FOR_EMAIL: `לא קיים חשבון עבור כתובת דוא״ל זו. בקשו מבית הספר ליצור חשבון ולאחר מכן התחברו.`,
	ERROR_NO_ACTIVE_ENROLLMENT: `אין לך רישום פעיל לסמסטר הנוכחי`,
	ERROR_REMOVING_COURSE: `שגיאה בהסרת קורס`,
	EXIT: `יציאה`,
	EXP: `תוקף`,
	FAILED: `הפעולה נכשלה`,
	FAILED_TO_COPY: `ההעתקה נכשלה`,
	FAILED_TO_RESET_PASSWORD: `איפוס הסיסמה נכשל`,
	FAILED_TO_SEND_RESET_EMAIL: `שליחת אימייל לאיפוס נכשלה`,
	FALSE: `לא נכון`,
	FAMILY: `משפחה`,
	FATHER: `אב`,
	FAVORITE: `מועדף`,
	FAVORITE_COURSE: `קורס מועדף`,
	FEMALE: `נקבה`,
	FILL_IN_THE_BLANK: `מלא את החלק`,
	FILTERS: `מסננים`,
	FILTER_STEP: `סנן שלב`,
	FILTER_STEPS: `סנן שלבים`,
	FINAL_SCORE: `ציון סופי`,
	FIRST_ATTEMPT_SCORE: `ציון בניסיון ראשון`,
	FIRST_NAME: `שם פרטי`,
	FLASH_SCHOOL_OF_ENGLISH: `flash school of english`,
	FLASH_STUDIES: `Flash Studies`,
	FOR: `ל`,
	FOR_A_WEEK_PLEASE_FILL_IN_THE_PAYMENT_INFORMATION: `לשבוע, יש למלא את פרטי התשלום`,
	FOR_CHILD: `לילד`,
	FORGOT_PASSWORD: `שכחתי סיסמה`,
	FORGOT_PASSWORD_ERROR: `שגיאת שכחת סיסמה`,
	FREE_TRIAL: `נסיון חינם`,
	FROM: `from`,
	FULL_NAME: `שם מלא`,
	GENERATE_ONE_TIME_TOKEN_FOR_CHILD: `צור קוד כניסה חד פעמי לילד`,
	GET_HELP: `עזרה`,
	GET_PLAN: `קבל מסלול`,
	GO_BACK: `חזור`,
	GO_TO_CLASSES: `עבור לכיתות`,
	GO_TO_CHILDREN: `עבור לילדים`,
	GO_TO_COURSE_STORE: `עבור לחנות הקורסים`,
	GO_TO_MY_CLASSES: `עבור לכיתות שלי`,
	GO_TO_MY_COURSE: `עבור לקורס שלי`,
	GO_TO_MY_COURSES: `עבור לקורסים שלי`,
	GO_TO_STORE: `עבור לחנות`,
	GO_TO_NEXT: `עבור לבא בתור`,
	GO_TO_PREVIOUS: `עבור לקודם`,
	GOOD_AFTERNOON: `אחר הצהריים טובים`,
	GOOD_EVENING: `ערב טוב`,
	GOOD_MORNING: `בוקר טוב`,
	GOOD_NIGHT: `לילה טוב`,
	HAVE_AN_ACCOUNT: `יש לך חשבון?`,
	HELP: `עזרה`,
	HELP_USAGE: `שימוש בעזרה`,
	HIDDEN_QUESTION: `שאלה מוסתרת`,
	HIDDEN_SENTENCE: `טקסט מוסתר`,
	HIDE: `הסתר`,
	HIDE_ADVANCED_SEARCH: `הסתר חיפוש מתקדם`,
	HIDE_COMMENTS: `הסתר הודעות`,
	HIDE_COMPLETED: `הסתר שהושלמו`,
	HOUR: `שעה`,
	IDENTIFICATION_NUMBER: `תעודת זהות של התלמיד/ה`,
	IF_EMAIL_EXISTS_RESET_LINK_SENT: `אם כתובת האימייל קיימת, נשלח קישור לאיפוס.`,
	IN_PROGRESS: `בתהליך`,
	INACTIVE: `לא פעיל`,
	INCOMPLETE: `לא הושלם`,
	INFORMATION: `מידע`,
	INSTALL: `התקן`,
	INSTALL_APP: `התקן אפליקציה`,
	INSTALL_APP_PROMPT_CAPTION: `קבל גישה מהירה יותר ותכונות לא מקוונות`,
	INSTALL_APP_PROMPT_MESSAGE: `התקן את אפליקציית SET`,
	IOS_INSTALL_TITLE: `התקנה ב-iPhone / iPad`,
	IOS_INSTALL_STEP0: `התקנת האפליקציה יכולה להתבצע רק דרך Safari`,
	IOS_INSTALL_STEP1: `פתח את Safari ועבור לאתר זה`,
	IOS_INSTALL_STEP2: `הקש על כפתור השיתוף (מלבן עם חץ)`,
	IOS_INSTALL_STEP3: `בחר [הוסף למסך הבית], ואחר כך הקש [הוסף]`,
	IOS_INSTALL_NOTE: `לאחר ההוספה, פתח את האפליקציה ממסך הבית`,
	INSTRUCTIONS: `הנחיות`,
	INTERIM_RESULTS: `תוצאות ביניים`,
	INVALID_NAME_FORMAT: `השם יכול להכיל רק אותיות, רווחים, מקפים ואפוסטרופים`,
	INVALID_VALUE: `ערך לא חוקי`,
	IT_WAS_WRITTEN_AS_AN_ERROR_AND_IMPACT_YOUR_SCORE: `זה נרשם כטעות וישפיע על הציון שלך`,
	IT_WILL_COUNT_AS_AN_ERROR: `זה יחשב כטעות`,
	IT_WILL_NOT_COUNT_AS_AN_ERROR: `לא יחשב כטעות`,
	LANGUAGE_SELECT: `שפה`,
	LAST_NAME: `שם משפחה`,
	LAST_PRACTICE: `תרגול אחרון`,
	LATER: `מאוחר יותר`,
	LICENSE: `רישיון`,
	LICENSE_ASSIGNED_SUCCESSFULLY_TO_CHILD: `הרישיון הוקצה בהצלחה לילד`,
	LICENSE_EXPIRED: `הרישיון פג תוקף`,
	LICENSE_REQUIRED_FOR_PREMIUM: `קורס פרימיום זה דורש רישיון פעיל.`,
	LICENSE_REQUIRED_REDIRECT_COURSES: `הרישיון שלך אינו תקף לתוכן פרימיום. מעבירים אותך לחנות הקורסים.`,
	LICENSE_VALID_UNTIL: `רישיון בתוקף עד`,
	LICENSES: `רישיונות`,
	LOCKED_FOR_STUDENTS: `נעול לתלמידים`,
	LOCKED_PREMIUM_COURSE: `פרימיום נעול`,
	LOCATION: `מיקום`,
	LOGIN: `כניסה`,
	LOGIN_TOKEN: `קוד כניסה`,
	LOGOUT: `יציאה`,
	LONGEST_STREAK: `הרצף הארוך ביותר`,
	MAIN_ACCOUNT: `חשבון ראשי`,
	MALE: `זכר`,
	MANUAL_COPY_INSTRUCTION: `אנא בחר את כל הטקסט למטה והעתק אותו ידנית:`,
	MAXIMUM_50_CHARACTERS: `עד 50 תווים`,
	MAX_AGE: `גיל מקס`,
	MAX_CHARACTERS: `מקסימום תווים`,
	MEMORY_FLIP: `משחק זיכרון`,
	MESSAGES: `הודעות`,
	MIC_NOT_SUPPORTED: `הדיבור אינו נתמך בדפדפן זה — הקלד את התשובה`,
	MIN_AGE: `גיל מינ`,
	MIN_CHARACTERS: `מינימום תווים`,
	MOBILE_NOT_FOUND: `מספר נייד לא נמצא`,
	MOBILE_NUMBER: `מספר נייד`,
	MOBILE_NUMBER_10_DIGITS: `מספר נייד בן 10 ספרות`,
	MOBILE_PHONE: `טלפון נייד`,
	MONTH: `חודש`,
	MONTHLY: `חודשי`,
	MOTHER: `אם`,
	MY_CLASSES: `הכיתות שלי`,
	MY_COURSES: `הקורסים שלי`,
	MY_FAVORITES: `המועדפים שלי`,
	MY_PROFILE: `הפרופיל שלי`,
	MY_PROFILE_DETAILS: `פרטי הפרופיל שלי`,
	MY_SECTIONS: `הפרקים שלי`,
	MY_STEPS: `השלבים שלי`,
	NAME: `שם`,
	NAME_2_TO_64: `2 עד 64 תווים`,
	NAVIGATION_MENU: `תפריט ניווט`,
	NEW_MESSAGE: `הודעה חדשה`,
	NEW_PASSWORD: `סיסמה חדשה`,
	NEW_TO_OUR_SYSTEM: `חדש במערכת שלנו?`,
	NEW_USER: `משתמש חדש`,
	NEXT: `הבא`,
	NEXT_STEP: `השלב הבא`,
	NO: `לא`,
	NO_CHILDREN_AVAILABLE: `אין ילדים זמינים`,
	NO_COURSES_AVAILIABLE_IN_STORE: `אין קורסים זמינים בחנות`,
	NO_DATA_AVAILIABLE: `נתונים לא זמינים`,
	NO_ERROR_MESSAGE_WILL_BE_SHOWN: `לא תוצג הודעת שגיאה`,
	NO_FEEDBACK_AVAILABLE: `אין משוב זמין`,
	NO_LICENSE: `אין רישיון`,
	NO_TASKS_MATCH_FILTERS: `אין משימות התואמות את הסינון`,
	NO_VALID_PAYMENT_DATA_FOUND_CHECKOUT_TO_PAY: `לא נמצאו פרטי תשלום חוקיים, עבור לתשלום`,
	NOT_SET: `לא נבחר`,
	NOT_STARTED: `לא התחיל`,
	NOTIFICATIONS_APPROVED: `קבלת התראות אושרה!`,
	NOTIFICATIONS_WERE_NOT_APPROVED: `התראות לא מאופשרות, כדי לשנות זאת יש ללחוץ על האייקון שנמצא לפני כתובת האתר בשורת הכתובת ואז לבחור - הגדרות אתר - למצוא את ההרשאות של התראות ולקבוע ידנית. `,
	NO_FAVORITES_AVAILABLE: `אין עדיין מועדפים`,
	OF: `מתוך`,
	OKAY: `אוקי`,
	OOPS_THIS_IS_THE_WRONG_ANSWER: `אופס! זו לא התשובה הנכונה`,
	ORGANIZATION: `ארגון`,
	ORGANIZATION_DETAILS: `פרטי ארגון`,
	ORGANIZATION_NAME: `שם ארגון`,
	ORGANIZATION_TYPE: `סוג ארגון`,
	ORGANIZATIONS: `ארגונים`,
	ORGANIZATIONS_LIST: `רשימת ארגונים`,
	OTHER: `אחר`,
	OWNED: `בעלות`,
	PAIRS: `קבוצות`,
	PARENT_ACCOUNT_LOGIN: `כניסה חשבון הורה`,
	PASSWORD: `סיסמה`,
	PASSWORD_RESET_SUCCESSFUL: `איפוס הסיסמה הצליח`,
	PASSWORD_UPDATED: `הסיסמה עודכנה`,
	PASSWORDS_MUST_MATCH: `הסיסמה חייבת להיות זהה`,
	PAUSE: `השהה`,
	PAYMENT: `תשלום`,
	PAYMENT_CONFIRMATION_TEXT: `התשלום עשוי להימשך עד 10 דקות לעיבוד. עם זאת, אנו נפעיל את הרישיון שלך, אם התשלום יידחה הרישיון יושבת.`,
	PAYMENT_CONFIRMATION_TITLE: `הזמנה התקבלה`,
	PERIOD: `תקופה`,
	PHONE: `טלפון`,
	PHONE_NUMBER: `מספר טלפון`,
	PITCH: `גובה`,
	PLAN: `מסלול`,
	PLAN_ERROR: `שגיאת מסלול`,
	PLAN_INFORMATION: `פרטי מסלול`,
	PLEASE_ENTER_A_VALID_EMAIL_ADDRESS: `נא להכניס כתובת אימייל חוקית`,
	PLEASE_ENTER_A_VALID_PASSWORD: `נא לבחור סיסמה חוקית`,
	PLEASE_ENTER_A_VALUE: `הזן ערך בבקשה`,
	PRACTICE: `תרגול`,
	PRESS_THE_PLAY_BUTTON_TO_HERE_THE_QUESTION: `לחץ על כפתור ההשמעה כדי לשמוע את השאלה`,
	PRICE: `מחיר`,
	PREVIEW: `תצוגה מקדימה`,
	PREVIEW_FAILED: `לא ניתן לפתוח את התצוגה המקדימה`,
	PROCESSING: `מעבד...`,
	PROFILE: `פרופיל`,
	PROFILE_SETTINGS: `הגדרות פרופיל`,
	PROGRESS_OVERVIEW: `סקירת התקדמות`,
	PROGRESS_SAVE_FAILED: `לא ניתן היה לשמור את ההתקדמות שלך. בדוק את החיבור לאינטרנט.`,
	PUT_THE_WORDS_IN_ORDER: `סדר את המילים`,
	QUERY: `בירור`,
	RATE: `קצב`,
	RECIEVE_NOTIFICATIONS: `קבלת התראות`,
	REDO_CURRENT: `חזור על הנוכחי`,
	REDO_SECTION: `חזור על פרק`,
	REGISTER: `הירשם`,
	REGISTRATION: `הרשמה`,
	REJECTED: `סורב`,
	RECENT_ACTIVITY: `פעילות אחרונה`,
	REMOVE_COURSE: `הסר קורס`,
	REMOVE_FROM_FAVORITES: `הסר מהמועדפים`,
	REQUESTED: `נשלח`,
	REQUIRED: `יש להזין ערך בשדה זה`,
	RESET: `איפוס`,
	RESET_CODE_MISSING: `קוד איפוס חסר`,
	RESET_PASSWORD: `אפס סיסמה`,
	RESET_PASSWORD_ERROR: `שגיאת איפוס סיסמה`,
	RESET_STEP: `איפוס שלב`,
	RESTART_COURSE: `איפוס קורס`,
	RESTART_SECTION: `איפос פרק`,
	RETRY: `נסה שוב`,
	RETYPE_PASSWORD: `הקלד סיסמה מחדש`,
	ROLE: `הרשאה`,
	SAVE: `שמור`,
	SAY_YOUR_ANSWER: `לחץ על המיקרופון ואמור את התשובה`,
	SCHOOL: `בית ספר`,
	SCHOOL_ACCOUNT_LOGIN: `כניסה לחשבון בית ספר`,
	SCHOOL_ACCOUNT_REGISTRATION: `הרשמת חשבון בית ספר`,
	SCHOOL_ADMIN_ACCOUNT: `חשבון מנהל בית ספר`,
	SCHOOL_ALL_CLASSES: `כל הכיתות`,
	SCHOOL_ALL_SCHOOLS: `כל בתי הספר`,
	SCHOOL_ALLOW_FUTURE_ASSIGNMENTS: `אפשר שיוך מראש`,
	SCHOOL_ALL_SEMESTERS: `כל הסמסטרים`,
	SCHOOL_APPLICATION_CANCELLED: `הבקשה בוטלה`,
	SCHOOL_APPLIED: `הוגשה בקשה`,
	SCHOOL_APPLY: `הגש בקשה`,
	SCHOOL_APPLY_SUCCESS: `הבקשה הוגשה. ממתין לאישור המורה.`,
	SCHOOL_ASSIGNED_COUNT: `שויכו`,
	SCHOOL_ASSIGNED_COURSES: `קורסים משויכים`,
	SCHOOL_ASSIGNED_LABEL: `משויך`,
	SCHOOL_ASSIGNED_STUDENTS_COUNTER: `{assignedCount} מתוך {totalCount} תלמידים משויכים`,
	SCHOOL_ASSIGN_COURSE: `שייך קורס`,
	SCHOOL_ASSIGN_INACTIVE_STUDENT: `ניתן לשייך עבודה חדשה רק לתלמידים פעילים.`,
	SCHOOL_ASSIGN_LOCKED_FUTURE: `הסמסטר טרם התחיל. הפעל \"אפשר שיוך מראש\" כדי לשייך קורסים ויחידות.`,
	SCHOOL_ASSIGN_LOCKED_PAST: `הסמסטר הסתיים. אפשר להסיר שיוכים, אך לא להוסיף חדשים.`,
	SCHOOL_ASSIGN_LOCKED_SEMESTER: `השיוך נעול עבור סמסטר זה.`,
	SCHOOL_ASSIGN_COURSE_FAILED: `נכשל שיוך הקורס לכיתה`,
	SCHOOL_ASSIGN_COURSE_SUMMARY: `שויך ל-{createdCount} תלמידים ({existingCount} כבר משויכים)`,
	SCHOOL_ASSIGN_COURSE_TO_STUDENTS: `שיוך לתלמידים`,
	SCHOOL_BULK_ASSIGNMENT_SUMMARY: `שויכו {courseCount} קורסים ו-{sectionCount} יחידות ל-{studentCount} תלמידים ({changedCount} שינויים, {unchangedCount} ללא שינוי)`,
	SCHOOL_CANCEL_APPLICATION: `ביטול בקשה`,
	SCHOOL_CLASS_APPROVE: `אישור`,
	SCHOOL_CLASS_COURSE_ASSIGNMENT: `שיוך קורסים לכיתה`,
	SCHOOL_CLASS_DECLINE: `דחייה`,
	SCHOOL_CLASS_DROP: `הסרה`,
	SCHOOL_CLASS_DROP_CONFIRM: `להסיר את {name} מהכיתה? פעולה זו מסיימת את הרישום לסמסטר.`,
	SCHOOL_CLASS_REINSTATE: `החזרה לכיתה`,
	SCHOOL_CLASS_REINSTATE_CONFIRM: `להחזיר את {name} לכיתה? הגישה לקורסים תשוחזר וההתקדמות תימשך מהנקודה שבה נעצרה.`,
	SCHOOL_COMPLETED_COUNT: `הושלמו`,
	SCHOOL_COPY_ENROLLMENT_LINK: `העתק קישור הצטרפות`,
	SCHOOL_COPY_REGISTRATION_LINK: `העתק קישור רישום`,
	SCHOOL_CREATE_ENROLLMENT: `יצירת רישום`,
	SCHOOL_CURRENT_SEMESTER: `סמסטר נוכחי: {name}`,
	SCHOOL_DECISION_SAVED: `ההחלטה נשמרה`,
	SCHOOL_ENROLLED: `רשום`,
	SCHOOL_ENROLLMENT_CREATE_SUCCESS: `הרישום נוצר בהצלחה`,
	SCHOOL_ENROLLMENT_DOCUMENT_ID: `מזהה מסמך רישום`,
	SCHOOL_ENROLLMENT_LINK_COPIED: `קישור ההצטרפות הועתק`,
	SCHOOL_ENROLLMENT_LINK_EXPLAIN: `לתלמידים שכבר יש להם חשבון — לחיצה אחת שולחת בקשה להצטרף לכיתה, ואתם מאשרים אותה.`,
	SCHOOL_ENROLLMENT_STATUS_LABEL: `הרשמה: {status}`,
	SCHOOL_FIND_CLASSES: `חיפוש כיתות`,
	SCHOOL_HIDE_INACTIVE_STUDENTS: `הסתר לא פעילים`,
	SCHOOL_INVITE_CLOSED_PAST_SEMESTER: `קישורי הזמנה אינם זמינים לסמסטר שהסתיים.`,
	SCHOOL_INVITE_FOR_SEMESTER: `עבור סמסטר: {name}`,
	SCHOOL_INVITE_LINKS: `קישורי הזמנה`,
	SCHOOL_INVITE_LINKS_HINT: `שתף קישור כדי לצרף תלמידים לכיתה זו.`,
	SCHOOL_JOIN_ERROR_CLASS_NOT_FOUND: `לא הצלחנו למצוא את הכיתה הזו. ייתכן שקישור ההזמנה אינו תקין או שהכיתה כבר אינה זמינה.`,
	SCHOOL_JOIN_ERROR_CLOSED: `לא ניתן עוד להשתמש בהזמנה זו כדי להצטרף לכיתה.`,
	SCHOOL_JOIN_ERROR_COMPLETED: `כבר סיימת את הכיתה הזו, אז אין למה להצטרף.`,
	SCHOOL_JOIN_ERROR_DECLINED: `הבקשה שלך להצטרף לכיתה נדחתה. בקש מהמורה הזמנה חדשה.`,
	SCHOOL_JOIN_ERROR_DROPPED: `הוסרת מהכיתה הזו. פנה למורה אם לדעתך מדובר בטעות.`,
	SCHOOL_JOIN_ERROR_GENERIC: `משהו השתבש בעת ההצטרפות לכיתה. נסה שוב.`,
	SCHOOL_JOIN_ERROR_INVALID_LINK: `קישור ההזמנה אינו תקין או שפג תוקפו.`,
	SCHOOL_JOIN_ERROR_SEMESTER_ENDED: `הסמסטר של הכיתה הזו הסתיים, ולכן היא אינה פתוחה עוד להרשמה.`,
	SCHOOL_JOIN_ERROR_TITLE: `לא ניתן להצטרף לכיתה זו`,
	SCHOOL_JOIN_GO_HOME: `עבור ללוח המחוונים`,
	SCHOOL_JOIN_RETRY: `נסה שוב`,
	SCHOOL_JOIN_STUDENTS_ONLY: `רק תלמידים יכולים להצטרף לכיתה.`,
	SCHOOL_JOIN_SUCCESS: `הבקשה נשלחה — המורה צריך לאשר אותך.`,
	SCHOOL_LOGIN_ROLE_MISMATCH: `התפקיד שנבחר לא תואם לתפקיד החשבון שלך.`,
	SCHOOL_NO_ASSIGNED_CLASSES_FOUND: `לא נמצאו כיתות משויכות.`,
	SCHOOL_NO_CLASSES_ASSIGNED_IN_SEMESTER: `לא הוקצו לך כיתות בסמסטר זה.`,
	SCHOOL_NO_CLASSES_AVAILABLE: `אין כיתות זמינות לבית ספר זה.`,
	SCHOOL_NO_CLASSES_FOR_SELECTED_SEMESTER: `לא נמצאו כיתות לסמסטר שנבחר.`,
	SCHOOL_NO_CURRENT_SEMESTER: `אין סמסטר פעיל כרגע. ההרשמה סגורה.`,
	SCHOOL_NO_ENROLLMENTS_FOR_THIS_SEMESTER: `לא נמצאו רישומים לסמסטר זה.`,
	SCHOOL_NO_STUDENTS_FOUND_FOR_CLASS: `לא נמצאו תלמידים בכיתה זו`,
	SCHOOL_NO_STUDENTS_MATCH_FILTER: `אין תלמידים התואמים את הסטטוסים שנבחרו`,
	SCHOOL_NOT_ASSIGNED_LABEL: `לא משויך`,
	SCHOOL_NOTES: `הערות`,
	SCHOOL_PROGRESS_PAUSED_SHORT: `ההתקדמות מושהית`,
	SCHOOL_REGISTER_SUCCESS: `חשבון בית הספר נוצר. ניתן להתחבר עם פרטי ההתחברות.`,
	SCHOOL_REGISTRATION_LINK_COPIED: `קישור הרישום הועתק`,
	SCHOOL_REGISTRATION_LINK_EXPLAIN: `לתלמידים שאין להם עדיין חשבון — הם נרשמים, ובקשה להצטרף לכיתה נשלחת לאישורכם.`,
	SCHOOL_SCORE_LABEL: `ציון: {score}`,
	SCHOOL_SEMESTER_LABEL: `סמסטר: {name}`,
	SCHOOL_SELECTED_COURSE: `קורס נבחר`,
	SCHOOL_SELECT_ASSIGNED_COURSE_TO_VIEW_PROGRESS: `בחר כרטיס קורס משויך כדי לראות התקדמות תלמידים.`,
	SCHOOL_SELECT_SCHOOL: `בחר בית ספר`,
	SCHOOL_SELECT_SEMESTER_TO_VIEW: `בחר סמסטר כדי לצפות בכיתות.`,
	SCHOOL_SHOW_INACTIVE_STUDENTS: `הצג לא פעילים ({count})`,
	SCHOOL_STATUS_ACTIVE: `פעיל`,
	SCHOOL_STATUS_COMPLETED: `הושלם`,
	SCHOOL_STATUS_DECLINED: `נדחה`,
	SCHOOL_STATUS_DROPPED: `הופסק`,
	SCHOOL_STATUS_PENDING: `ממתין`,
	SCHOOL_STUDENT_DOCUMENT_ID: `מזהה מסמך תלמיד`,
	SCHOOL_STUDENTS_PROGRESS_FOR_COURSE: `התקדמות תלמידים בקורס זה`,
	SCHOOL_STUDENTS_COUNT: `תלמידים`,
	SCHOOL_UNASSIGNED_PROGRESS_PAUSED_MESSAGE: `ההתקדמות עבור תוכן שאינו משויך מושהית.`,
	SCHOOL_UPDATE_ENROLLMENT: `עדכון רישום`,
	SCHOOL_ENROLLMENT_UPDATE_SUCCESS: `הרישום עודכן בהצלחה`,
	SCHOOL_LAST_ACTIVE: `פעיל/ה {when}`,
	SCHOOL_NEVER_ACTIVE: `טרם התחבר/ה`,
	SCHOOL_SELECT_ALL: `בחר הכול`,
	SCHOOL_UNASSIGN: `ביטול שיוך`,
	SCHOOL_UNASSIGN_COMPLETED_CONFIRM: `{name} כבר השלים/ה את {entity}. ביטול השיוך יסתיר את התוכן; ההתקדמות והציון נשמרים ויחזרו אם תשייכו שוב. לבטל בכל זאת?`,
	SCHOOL_UNASSIGN_STARTED_CONFIRM: `{name} כבר התחיל/ה את {entity}. ביטול השיוך יעצור את ההמשך; ההתקדמות נשמרת ותחזור אם תשייכו שוב. לבטל בכל זאת?`,
	SCHOOL_UNASSIGN_STARTED_TITLE: `התלמיד/ה כבר התחיל/ה`,
	SCHOOL_UNSELECT_ALL: `נקה הכול`,
	SCORE: `ציון`,
	SEARCH: `חיפוש`,
	SEARCH_BY_NAME: `חיפוש לפי שם`,
	SECTION: `פרק`,
	SECTION_COMPLETED: `הפרק הושלם`,
	SECTION_PREVIEW: `תצוגה מקדימה של פרקים`,
	SECTION_STORE: `חנות פרקים`,
	SECTIONS: `פרקים`,
	SECURITY: `אבטחה`,
	SECURITY_SETTINGS: `הגדרות אבטחה`,
	SELECT: `בחר`,
	SELECTED_PLAN: `התוכנית שנבחרה`,
	SELECT_ALL: `בחר הכול`,
	SELECT_AND_ASSIGN: `בחירה ושיוך`,
	SELECT_AND_COPY_TEXT_BELOW: `בחר והעתק את הטקסט למטה`,
	SELECT_APPEARANCE: `בחר ערכת נושא`,
	SELECT_CITY_FIRST: `אנא בחר עיר תחילה`,
	SELECT_LANGUAGE: `בחר שפה`,
	SELECT_ONE_OPTION_TO_ANSWER: `בחר אפשרות אחת לתשובה`,
	SELECT_SYSTEM_LANGUAGE: `בחר שפת מערכת`,
	SEND_REQUEST: `שלח בקשה`,
	SEND_RESET_LINK: `שלח קישור לאיפוס`,
	SENTENCE_BUILDER: `בניית משפט`,
	SETTINGS: `הגדרות`,
	SEX: `מין`,
	SEMESTER: `סמסטר`,
	SEMESTER_TAG_CURRENT: `נוכחי`,
	SEMESTER_TAG_PAST: `הסתיים`,
	SEMESTER_TAG_UPCOMING: `עתידי`,
	SHARE_CODE: `שתף קוד`,
	SHOW_COMMENTS: `הצג הודעות`,
	SHOW_INFO: `הצג מידע`,
	SIGN_IN: `התחבר`,
	SIGN_IN_SUCCESS: `התחברות הציחה`,
	SIGN_OUT: `התנתק`,
	SIGNING_IN: `התחברות`,
	SINGLE_CHOICE: `בחירה אחת`,
	SKIP: `דלג`,
	SKIPPED: `דלג`,
	SOMETHING_WENT_WRONG: `משהו השתבש`,
	SORT: `מיון`,
	SORT_BY: `מיין לפי`,
	SORT_HIGHEST_SCORE_FIRST: `ציון גבוה תחילה`,
	SORT_LOWEST_SCORE_FIRST: `ציון נמוך תחילה`,
	SORT_NAME_A_Z: `שם א-ת`,
	SORT_RECENTLY_WORKED_ON: `עבדת לאחרונה`,
	SPEAK_THE_TEXT: `דבר את הטקסט`,
	START: `התחלה`,
	START_DATE: `תאריך התחלה`,
	STATUS: `סטטוס`,
	STEP: `שלב`,
	STEP_INCOMPLETE_DATA: `נתוני שלב לא שלמים`,
	STEP_LOAD_ERROR: `שגיאה בטעינת שלב`,
	STEP_NOT_FOUND: `שלב לא נמצא`,
	STEP_RESULTS: `תוצאות שלב`,
	STEPS: `שלבים`,
	STEP_FEEDBACK_GO_BACK_MESSAGE: `חזרו לשלב הקודם, ואז נסו שוב את השלב הזה.`,
	STEP_FEEDBACK_GO_BACK_TITLE: `נחזור שלב אחד אחורה`,
	STEP_FEEDBACK_PASS_SCORE: `כדי להמשיך צריך {score}%.`,
	STEP_FEEDBACK_REDO_MESSAGE: `נתרגל את השלב הזה פעם נוספת.`,
	STEP_FEEDBACK_REDO_TITLE: `ננסה את השלב הזה שוב`,
	STEP_FEEDBACK_SCORE: `קיבלתם {score}%.`,
	STOP: `עצור`,
	STORAGE_CLEARED_ERROR: `לא ניתן היה לנקות את זיכרון האפליקציה. נסו שוב.`,
	STORAGE_CLEARED_SUCCESS: `ניקוי זיכרון האפליקציה הצליח`,
	STORAGE_CLEARED_SUCCESS_CAPTION: `זיכרון האפליקציה נוקה בהצלחה. כעת באפשרותך להפעיל מחדש את האפליקציה.`,
	STREET: `רחוב`,
	STREET_NUMBER: `מספר`,
	STUDENT: `תלמיד`,
	STUDENT_ACCOUNT: `חשבון תלמיד`,
	STUDENT_MY_CLASSES: `הכיתות שלי`,
	STUDENT_NO_CLASSES: `עדיין אינך רשום לאף כיתה. בקש מהמורה קישור הצטרפות.`,
	STUDENT_NO_CLASSES_IN_SEMESTER: `אין כיתות בסמסטר זה.`,
	STUDENT_SEMESTER_CURRENT: `סמסטר נוכחי`,
	STUDENT_SEMESTER_UPCOMING: `סמסטר קרוב`,
	STUDENT_STATISTICS: `סטטיסטיקת תלמיד`,
	STUDENTS: `תלמידים`,
	SUBMIT: `שלח`,
	SUBSCRIPTION_CREATED_SUCCESSFULLY: `המנוי נוצר בהצלחה`,
	SUBSCRIPTION_UPDATED_SUCCESSFULLY: `המנוי עודכן בהצלחה`,
	SUPER_ADMIN: `משתמש על`,
	SYSTEM_LANGUAGE: `שפת המערכת`,
	TAKE_COURSE: `קח קורס`,
	TEACHER_PREVIEW_BANNER: `מצב תצוגה מקדימה — אתה צופה בתוכן כפי שהתלמידים שלך יראו אותו. ההתקדמות שלך כאן אינה התקדמות של תלמיד.`,
	TEACHER_ACCOUNT: `חשבון מורה`,
	TEACHERS: `מורים`,
	TERMS_OF_TRANSITION: `תנאי מעבר`,
	THEME_DARK: `כהה`,
	THEME_LIGHT: `בהיר`,
	THEME_SYSTEM: `מערכת`,
	THE_QUESTION_IS_HEARD: `השאלה נשמעת`,
	THE_QUESTION_IS_NOT_HEARD: `השאלה לא נשמעת`,
	THE_QUESTION_TEXT_IS_NOT_SHOWN: `הטקסט של השאלה לא מוצג`,
	THE_QUESTION_TEXT_IS_SHOWN: `הטקסט של השאלה מוצג`,
	THE_SUBSCRIPTION_PERIOD_WILL_BE_CHANGED_TO: `{period}תקופת המנוי תשתנה ל`,
	THEORY_STEP: `שלב תיאוריה`,
	THEORY_STEP_INFORMATION_TEXT: `טקסט מידע על שלב תיאוריה`,
	TIME: `זמן`,
	TITLE: `כותרת`,
	TO: `עד`,
	TO_GET_A: `כדי לקבל`,
	TODAY: `היום`,
	TOGGLE: `החלף`,
	TOTAL: `סך שיעורים`,
	TOTAL_USAGE_TIME: `זמן שימוש כולל`,
	TRUE: `נכון`,
	TRUE_FALSE: `נכון / לא נכון`,
	TRY_AGAIN: `נסה שוב`,
	TYPE: `סוג`,
	TYPE_INSTEAD: `הקלד במקום`,
	TYPE_OR_SAY_YOUR_ANSWER_HERE: `הקלד או אמור את התשובה`,
	TYPE_YOUR_ANSWER_HERE: `הקלד את התשובה`,
	UNASSIGNED_LICENSE: `רישיון לא משוייך`,
	UNFAVORITE_COURSE: `בטל סימון קורס מועדף`,
	UNFORTUNATLY_WE_COULD_NOT_LOAD_THE_USER_DATA: `לא הצלחנו לטעון את נתוני המשתמש`,
	UNKNOWN: `לא נבחר`,
	UNSUBSCRIBE: `בטל מנוי`,
	UNSUBSCRIBE_FAILED: `ביטול המנוי נכשל`,
	UNSUBSCRIBED_SUCCESSFULLY: `בוטל המנוי בהצלחה`,
	UPDATE: `עדכן`,
	UPDATE_SUBSCRIPTION_PERIOD_FAILED: `שינוי תקופת המנוי נכשל`,
	UPDATE_SUBSCRIPTION_PERIOD_SUCCESS: `תקופת המנוי עודכנה בהצלחה`,
	USER_DETAILS: `פרטי משתמש`,
	USER_MANAGEMENT: `ניהול משתמשים`,
	USER_MANAGMENT: `ניהול משתמשים(עובדי הוראה)`,
	USER_NOT_FOUND: `משתמש לא נמצא`,
	USERNAME: `שם משתמש`,
	USERNAME_OR_EMAIL: `שם משתמש/אימייל`,
	USERS: `משתמשים`,
	USERS_LIST: `רשימת משתמשים`,
	USER_NOT_LOGGED_IN: `אינכם מחוברים`,
	VALID_EMAIL_ADDRESS: `כתובת אימייל חוקית`,
	VALID_UNTIL: `תקף עד`,
	VALIDATE_INVALID_PHONE: `נדרש מספר נייד חוקי`,
	VALIDATE_MIN_2_CHARS: `יש להזין לפחות שני תווים`,
	VALIDATE_MIN_2_MAX_20: `הערך צריך להיות 2 עד 20 תווים`,
	VERIFY: `אימות`,
	VIDEO_LOADING: `טוען סרטון…`,
	VIDEO_LOAD_ERROR: `לא ניתן היה לטעון את הסרטון`,
	VIEW_RESULTS: `הצג תוצאות`,
	VIEW_STATISTICS: `הצג סטטיסטיקה`,
	WEELKLY: `שבועי`,
	WELCOME_BACK_MESSAGE: `מוכן להמשיך במסע הלמידה שלך?`,
	WELCOME_BACK_MESSAGE_PARENT: `ברוך שובך! בחר ילד כדי להמשיך במסע הלמידה שלו.`,
	WELCOME_BACK_MESSAGE_STUDENT: `ברוך שובך! מוכן להמשיך ללמוד?`,
	WELCOME_BACK_MESSAGE_TEACHER: `ברוך שובך! הנה סקירה של הכיתות שלך.`,
	WELCOME_TO: `ברוכים הבאים ל`,
	WHEN_YOU_HAVE_A_MISTAKE: `כאשר יש לך טעות`,
	WORD_BUILDER: `בניית מילה`,
	WRONG_ANSWER: `תשובה שגויה`,
	YEAR: `שנה`,
	YEARLY: `שנתי`,
	YES: `כן`,
	YOU_CAN_CORRECT_YOUR_ANSWER_THE_QUESTION_WILL_REPEATE: `ניתן לתקן את התשובה, השאלה תחזור`,
	YOU_CAN_NOT_CORRECT_YOUR_ANSWER_THE_NEXT_QUESTION_WILL_BE_SHOWN: `לא ניתן לתקן את התשובה, השאלה הבאה תוצג`,
	YOU_DID_GOOD_ON_PREVIOUS_STEPPS_THIS_FILTER_STEP_IS_NOT_NEEDED: `עשית טוב בשלבים הקודמים, שלב זה לא נדרש`,
	YOU_DID_GOOD_ON_PREVIOUS_STEPS: `עשית טוב בשלבים הקודמים`,
	YOU_DID_NOT_MEET_THE_TERMS_OF_TRANSITION_FOR_THE_SECTION_REDO: `לא עמדת בתנאי המעבר של השלב, חזור?`,
	YOU_HAVE_COMPLETED_THIS_COURSE_BACK_TO_COURSES: `סיימת את הקורס! חזרה לקורסים`,
	YOU_HAVE_COMPLETED_THIS_SECTION_WOULD_YOU_LIKE_TO_PROCEED: `סיימת את הפרק. האם תרצה להמשיך?`,
	YOU_HAVE_COMPLETED_THIS_STEP: `סיימת את השלב`,
	YOU_WILL_BE_SHOWN_THE_ANSWER_COMPARISON: `תוצג ל השוואת תשובה`,
	YOUR_ANSWER: `תשובתך`,
	YOUR_SECTIONS: `הפרקים שלך`,
	YOUR_SUBSCRIPTION_WILL_ONLY_UPDATE_THE_PRICE: `המנוי שלך יעודכן במחיר בלבד`,
	ZIPCODE: `מיקוד`,
}